import React from 'react';
import './ClientPage.css';

import { Heading, PageTitle } from '../../../components';
import { clients } from '../../../constants';



const ClientPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Clients'} page={'Clients'} />

      <section className='clients'>

        {/* Section heading */}
        <Heading title={'Our Clients'} />

        <div className='box-container'>

          {/* Loop through the clients array to display each client's logo */}
          {clients.map((client, index) => {
            return (
              <div className='client-item' key={index}>
                {/* Render the client logo */}
                <img src={client} alt='Client Logo' />
              </div>
            );
            })
          }

        </div>

      </section>

    </>
  );
}

export default ClientPage;